import { AboutUs } from './AboutUs'
import { BookTable } from './BookTable'
import { Main } from './Main'
import { Decoration } from './Decoration'
import { OtherRestaurants } from './OtherRestaurants'
import { Contacts } from './Contacts'

export const Layout = { Main, BookTable, AboutUs, Decoration, OtherRestaurants, Contacts }
